export default __webpack_public_path__ + "static/media/check-2.c7df5b1e.svg";